import "./CreateInvoiceModal.css";
import "./DiscountType.css";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import {
  getCreateInvoicePopupMetaData,
  getCreateInvoicePopupMetaDataValues,
  initialDiscountState,
} from "./ViewOrderUtils";
import { useState, useEffect, KeyboardEvent } from "react";
import { CreateInvoiceModalProps } from "./ViewOrderType";
import Switch from "react-switch";
import DiscountType from "./DiscountType";
import CircularProgress from "@mui/material/CircularProgress";
import { Tooltip } from "@mui/material";
import ScreenOverlay from "../../components/dms_common/ScreenOverlay";
import { truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import useShortcutKeys from "../../components/dms_common/ShortcutKeys";

const CreateInvoiceModal: React.FC<CreateInvoiceModalProps> = ({
  modalOpen,
  handleModalClose,
  orderData,
  handleOnSave,
  discount,
  setDiscount,
  invoiceLoading,
  hideAdditionalDistributorDiscount = false,
  orderWillGet,
  hideCouponDiscount
}) => {
  const [finalAmount, setFinalAmount] = useState<number>(0);

  useEffect(() => {
    const totalMrp = orderData?.netAmount || 0;
    const discountValue =
      discount?.discountType === "VALUE"
        ? parseFloat(discount?.discountValue || "0")
        : (parseFloat(discount?.discountValue || "0") / 100) * totalMrp;

    const finalAmount = totalMrp - discountValue;

    setFinalAmount(Number(truncateToTwoDecimals(finalAmount)));
  }, [orderData, discount]);

  const handleSwitchChange = (checked: boolean) => {
    if (!checked) {
      setDiscount(initialDiscountState);
    } else {
      setDiscount((prevDiscount) => ({
        ...prevDiscount,
        discountApplied: checked,
      }));
    }
  };

  const handleRadioToggle = (value: "VALUE" | "PERCENTAGE") => {
    setDiscount((prevDiscount) => ({
      ...prevDiscount,
      discountValue: "",
      discountType: value,
    }));
  };

  const handleDiscountValueChange = (value: string) => {
    setDiscount((prevDiscount) => ({
      ...prevDiscount,
      discountValue: value,
    }));
  };

  const handleResetChanges = () => {
    setDiscount({ ...initialDiscountState, discountApplied: true });
  };

  const reset = () => {
    setDiscount(initialDiscountState);
    setFinalAmount(0);
  };

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const designationBasedUomSecondary = ConfigDictionary.designationBasedUomSecondary;
  let createInvoiceOrderDetailsMetaDataValues: any = {};
  createInvoiceOrderDetailsMetaDataValues = getCreateInvoicePopupMetaDataValues(orderData);

  const designationEnabled  =  designationBasedUomSecondary?.enable ?? false;
  const availableDesignations = designationBasedUomSecondary?.roles?.designationKeys?.map(((item: { type: any; }) => item?.type)) || [];
  const currentDesignation = JSON.parse(localStorage.authContext).user.designation || [];
  const designation = availableDesignations.find((type: any) => 
    currentDesignation.includes(type)
  );
  const designationKeys = designationBasedUomSecondary?.roles?.designationKeys ?? [];
  const matchedRole = designationKeys.find((role: { type: string; uomAllowed: any }) => role.type === designation);

    const handleSwitchKeyDown = (event: KeyboardEvent) => {
    // Check if the pressed key is 'Enter' or ' ' (Space)
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault(); // Prevent default action (like form submission or scrolling)
      handleSwitchChange(!discount?.discountApplied); // Toggle the switch state
    }
  };

    useEffect(() => {
    const handleKeyDown = (event: globalThis.KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "a" && modalOpen) {
        event.preventDefault();
        if (!invoiceLoading) {
          handleOnSave("");
        }
      } else if (event.key === "Escape") {
        event.preventDefault();
        reset();
        handleModalClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleOnSave, invoiceLoading, handleModalClose]);

  

  const { positiveCta } = useShortcutKeys();

  return (
    <Modal
      open={modalOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="create-invoice-modal-container">
      <ScreenOverlay apply={invoiceLoading} />
        <Tooltip title={orderData?.orderNumber}>
          <div className="createInvoiceModalHeader">
            <p>Create Invoice for : {orderData?.orderNumber}</p>
            <button onClick={() => {
        reset();
        handleModalClose();
      }} style={{ border: "none", background: "none" }}>
            <CloseIcon style={{ cursor: "pointer" }}  />
            </button>
          </div>
        </Tooltip>

        <div className="createInvoice-orderDetails">
          {getCreateInvoicePopupMetaData(hideCouponDiscount)?.map((obj: any) => {
            const { key, value, color, currencySymbol } = obj;
            if (designationEnabled && designation && designationKeys && matchedRole && (key === "QTY(CS)" || key === "QTY(PC)")){
              const elementToKeep = matchedRole?.uomAllowed?.case ? "QTY(CS)" : "QTY(PC)";
              if (elementToKeep !== key){
                return null
              }
            }

            return (
              <div className="createInvoice-orderDetailTile" key={key}>
                <span style={color ? { color: color, fontWeight: 500 } : {}}>{key}</span>
                <span style={color ? { color: color, fontWeight: 600 } : {}}>
                  {currencySymbol ? ConfigDictionary.currency : ""}{" "}
                  {createInvoiceOrderDetailsMetaDataValues?.[value]}
                </span>
              </div>
            );
          })}
        </div>

        {!hideAdditionalDistributorDiscount && (
        <div className="add-discount-container">
          <div className="toggleContainer">
            <p>Additional distributor discount</p>
            <Switch
              onKeyDown={handleSwitchKeyDown}
              onChange={handleSwitchChange}
              checked={discount?.discountApplied}
              offColor="#9ba09f"
              onColor="#00C6B1"
              handleDiameter={16.2}
              uncheckedIcon={false}
              checkedIcon={false}
              height={20.7}
              width={42.6}
            />
          </div>

          {discount?.discountApplied && (
            <div className="discount-configure-container">
              <DiscountType
                type="Value"
                handleRadioToggle={() => handleRadioToggle("VALUE")}
                discount={discount}
                handleDiscountValueChange={handleDiscountValueChange}
                maxVal={orderData?.netAmount}
              />
              <DiscountType
                type="Percentage"
                handleRadioToggle={() => handleRadioToggle("PERCENTAGE")}
                discount={discount}
                labelSuffix="%"
                handleDiscountValueChange={handleDiscountValueChange}
                maxVal={100}
              />
            </div>
          )}

          {discount?.discountApplied && (
            <div className="final-amount-container">
              <p>
                Final amount (after additional discount):{" "}
                <span>
                  {ConfigDictionary.currency}
                  {finalAmount}
                </span>
              </p>
            </div>
          )}
        </div>
      )}

        <div className="createInvoice-footerContainer" style={{justifyContent: "flex-end"}}>
          {
            (orderWillGet !== "INVOICED") && 
            <span style={{color: "red", fontSize: "12px", fontStyle: "italic", width: "100%", alignItems: "start"}}>
              {
                (orderWillGet === "REJECTED") ?
                <div style={{display: "flex", flexDirection: "column", alignItems: "start"}}>
                  <span>Order will get rejected due to unavailability of stock.</span>
                  <span>Do you wish to proceed?</span>
                </div>
                : (orderWillGet === "PARTIALLY INVOICED") ?
                <div style={{display: "flex", flexDirection: "column", alignItems: "start"}}>
                  <span>Order will be partially invoiced due to partial availability of stock.</span>
                  <span>Do you wish to proceed?</span>
                </div>
                :
                <></>
              }
            </span>
          }
          <div style={{display: "flex", gap: "10px", whiteSpace: "nowrap"}}>
          {+discount?.discountValue > 0 && (
            <button className="invoice-reset-changes" onClick={handleResetChanges}>
              <span>Reset</span>
            </button>
          )}
          <button
            className="invoice-reset-changes"
            style={{ backgroundColor: "#00C6B1", borderColor: "#00C6B1" }}
            onClick={() => handleOnSave("")}
            disabled={invoiceLoading}
          >
            <span
              style={{
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {invoiceLoading ? (
                <CircularProgress
                  style={{
                    width: 20,
                    height: 20,
                    color: "#fff",
                  }}
                />
              ) : (
                "Proceed"
              )}
            </span>
            {!invoiceLoading && <span style={{fontSize:"9.5px", color: "#fff"}}>{positiveCta}</span>}
          </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateInvoiceModal;
